export const salaryData = [
    { category: "AI 개발자 신입", minSalary: "4000만원" },
    { category: "1년 경력 개발자", minSalary: "4500만원" },
    { category: "2~4년 경력 개발자", minSalary: "5200만원" },
    { category: "5~9년 경력 개발자", minSalary: "6400만원" },
    { category: "10년 이상 경력 개발자", minSalary: "8500만원" },
];
